import { render, staticRenderFns } from "./ProductCategoryComponent.vue?vue&type=template&id=251b7c16"
import script from "./ProductCategoryComponent.vue?vue&type=script&lang=js"
export * from "./ProductCategoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports